<template>
  <v-dialog :value="value" width="500px" persistent>
    <v-card>
      <v-card-title>Enviar e-mail de teste</v-card-title>
      <v-card-text>
        <v-row justify="center">
          <v-col cols="10">
            <label class="detail-title">Destinatário para e-mail de teste</label>
            <v-text-field v-model="recipient" class="mb-0" outlined hide-details />
          </v-col>
        </v-row>
        <mf-action-buttons
          :primary-button="{
            text: 'Enviar',
            action: send,
            isVisible: true,
            isLoading: loading,
          }"
          :extra-button="{
            text: 'Cancelar',
            action: () => $emit('input', false),
            isVisible: true,
            isDisabled: loading,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    credentials: Object,
    domain: String,
    senderName: String,
  },
  data: () => ({
    recipient: '',
    loading: false,
  }),
  methods: {
    async send() {
      const url = 'https://qx3pm.api.infobip.com/email/2/send'
      const formData = new FormData()

      let from = this.domain
      if (this.senderName) {
        from = `${this.senderName} <${this.domain}>`
      }

      formData.append('from', from)
      formData.append('to', this.recipient)

      formData.append('subject', 'Test e-mail subject')
      formData.append('html', '<h1>Test e-mail body</h1>')
      this.loading = true
      let response
      try {
        response = await fetch(url, {
          method: 'POST',
          body: formData,
          credentials: 'include',
          headers: {
            Authorization: 'Basic ' + btoa(this.credentials.login + ':' + this.credentials.password),
          },
        })
      } catch (e) {
        this.$snackbar({ message: `Erro ao enviar email: ${e}`, snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
      if (!response.ok) {
        this.$snackbar({ message: `Erro ao enviar email com status ${response.status}`, snackbarColor: 'error' })
      } else {
        this.$snackbar({ message: 'E-mail enviado com sucesso', snackbarColor: 'success' })
      }
      this.$emit('input', false)
    },
  },
}
</script>
